<!-- main app container -->
<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span  jhiTranslate="program.create.title">Add a new Program</span>&nbsp;
        <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row required">
            <label for="cropDropdown" class="col-sm-4 col-form-label fw-bold" jhiTranslate="program.crop">Crop</label>
            <div class="col-sm-6">
                <ng-select name="cropDropdown" id="cropDropdown" width="100%" data-test="cropDropdown"
                            [items]="crops"
                            [(ngModel)]="cropName"
                            placeholder="{{ 'program.crop.select' | translate }}"
                            [clearable]="true"
                            (ngModelChange)="onCropChange()">
                </ng-select>
            </div>
            <div class="col-sm-auto">
                <div class="throbber" *ngIf="isLoading"></div>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="programName" class="col-sm-4 col-form-label fw-bold" jhiTranslate="program.program-name">Program Name</label>
            <div class="col-sm-5">
                <input type="text" class="form-control" name="programName" id="programName" data-test="programNameTextbox"
                       [(ngModel)]="program.name" #programName="ngModel" [maxLength]="50" required/>
            </div>
        </div>
        <div class="mb-3 row required">
            <label class="col-sm-4 col-form-label fw-bold" jhiTranslate="program.program-start-date">Program Start Date</label>
            <div class="col-sm-7">
                <div class="input-group col-sm-4">
                    <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="startDate" data-test="startDateTextbox"
                           ngbDatepicker #date="ngbDatepicker" id="date" name="date" required/>
                    <button class="btn btn-outline-secondary calendar" (click)="date.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="dropdownBreedingLocations" class="col-sm-4 col-form-label fw-bold" jhiTranslate="program.program-breeding-default-location">Location</label>
            <div class="col-sm-7">
                <jhi-locations-select id="dropdownBreedingLocations"
                    [(value)]="breedingLocationDefaultId"
                    [cropName]="cropName"
                    [showFilterOptions]="true"
                    [disabled]="!cropName"
                    [showFavoritesCheckbox]="false">
                </jhi-locations-select>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="dropdownStorageLocations" class="col-sm-4 col-form-label fw-bold" jhiTranslate="program.program-storage-default-location">Location</label>
            <div class="col-sm-7">
                <jhi-locations-select id="dropdownStorageLocations"
                    [(value)]="storageLocationDefaultId"
                    [cropName]="cropName"
                    [showFilterOptions]="false"
                    [disabled]="!cropName"
                    [showFavoritesCheckbox]="false"
                    [storageLocationsOnly]="true">
                </jhi-locations-select>
            </div>
        </div>

    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="create(f)" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="saveProgramButton">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
    </button>
</div>

